import { v4 as uuid } from "uuid";

export const products = [
  {
    id: uuid(),
    title: "Basketball",
    price: 109.95,
    description:
      "Official NBA basketball suitable for indoor and outdoor play.",
    category: "Basketball",
    image: "https://m.media-amazon.com/images/I/81bhXMMEteL._AC_UL320_.jpg",
    rating: {
      rate: 4.3,
      count: 420,
    },
  },
  {
    id: uuid(),
    title:
      "Klapp Popular Willow Cricket Kit With Three Ball, Four Wicket For Boys And Youth (Bat Size:3 ; Off White) ",
    price: 616,
    description:
      "BEST FOR 3 TO 8 YEARS  POPULAR WILLOW SIZE 1 BAT,3 BALL,1 COVER,1 BAT,4 WICKET STUMPS ",
    category: "Cricket",
    image: "https://m.media-amazon.com/images/I/61lNKZPwwNL._AC_UL320_.jpg",
    rating: {
      rate: 3.9,
      count: 120,
    },
  },
  {
    id: uuid(),
    title: "SS Cr.Balls0054 Poly Soft Ball, Cricket, Maroon",
    price: 190,
    description:
      "Slim-fitting style, contrast raglan long sleeve, three-button henley placket, light weight & soft fabric for breathable and comfortable wearing. And Solid stitched shirts with round neck made for durability and a great fit for casual fashion wear and diehard baseball fans. The Henley style round neckline includes a three-button placket.",
    category: "Cricket",
    image: "https://m.media-amazon.com/images/I/81zbgpm9mOL._AC_UL320_.jpg",
    rating: {
      rate: 4.1,
      count: 259,
    },
  },
  {
    id: uuid(),
    title: "SG Prokick Kashmir Willow Cricket Bat, Size - 5",
    price: 1799,
    description:
      "Kashmir willow hard pressed & traditionally shaped. Made from top quality Finest Kashmir willowHandle shape-traditional Round cane handleÂ for supereme grip and overall Bat control. Suitable for : Leather Ball Handle Shape: Traditional round cane handle for supreme grip and overall bat control. Pronounced bow for improved pick-up, Singapore cane handle for maximum shock absorption, Massive edges and exquisite balance and Extended power zone for monstrous hitting area.",
    category: "Cricket",
    image: "https://m.media-amazon.com/images/I/51O0jQGkMjS._AC_UL320_.jpg",
    rating: {
      rate: 4.7,
      count: 500,
    },
  },
  {
    id: uuid(),
    title:
      "Liffo® LX-1001 Hockey Sticks for Men and Women Practice and Beginner Level with Ball (L-36 Inc) Red",
    price: 419,
    description:
      "Made up with Solid Wood material attractive and durableAttractive, durable and high grip to use Ideal for kids, men, women, adult Hockey Stick for Practice and Beginner Level ",
    category: "Hockey",
    image: "https://m.media-amazon.com/images/I/41qqhMybyaL._AC_UL320_.jpg",
    rating: {
      rate: 2.1,
      count: 430,
    },
  },
  {
    id: uuid(),
    title:
      "Vector X VXT-520 Strung Tennis Racquet with Cover, 26-inch (Blue/White) ",
    price: 1199,
    description:
      "Heavy Construction For Exceptional PerformanceHead Shape:- Oval Shape, Length-66.04 cmFull Padded Cover Included Strung Type:- Strung, Lightweight",
    category: "Tennis",
    image: "https://m.media-amazon.com/images/I/61lf3IMGC-L._AC_UL320_.jpg",
    rating: {
      rate: 4.6,
      count: 400,
    },
  },
  {
    id: uuid(),
    title: "HEAD Novak 25 2022 Tennis Racquet ,Turquoise,Aluminum",
    price: 2169,
    description:
      "Playability: This Tennis racquet for men and women offers great feel and controllable power to Junior players. String pattern: Wider Cross-Strings (Open 16x19 string pattern) for added Power and Spin.",
    category: "Tennis",
    image: "https://m.media-amazon.com/images/I/61lf3IMGC-L._AC_UL320_.jpg",
    rating: {
      rate: 3.5,
      count: 70,
    },
  },
  {
    id: uuid(),
    title: "Table Tennis Racket Sportneer 2 PCS 4 Star Table Tennis",
    price: 869,
    description:
      "Ideal for all levels of experience: Whether you are an experienced professional, a complete amateur or somewhere in between, this table tennis kit is suitable for everyone! These table tennis racket offer excellent spin and control to take your game to the next level. ",
    category: "Table Tennis",
    image: "https://m.media-amazon.com/images/I/81nt5NxRDvL._AC_UL320_.jpg",
    rating: {
      rate: 3.0,
      count: 400,
    },
  },
  {
    id: uuid(),
    title: "Head Tennis Ball Championship 1 Can | 3 Balls",
    price: 484,
    description:
      "Durable, Comfortable & easy to play ball Court Training Perfect for a quick hit or game on every surface Easy-to-play ball for club players and beginners ",
    category: "Tennis",
    image: "https://m.media-amazon.com/images/I/519ASrsmi0L._AC_UL320_.jpg",
    rating: {
      rate: 4.1,
      count: 180,
    },
  },
  {
    id: uuid(),
    title: "Nivia Storm Football",
    price: 380,
    description:
      "High Gloss PU Synthetic leather stitched with Collar ankle mesh A moulded Removable P.U(SPORTHO FOOT COMFORT ) sockliner Soft cushion NR EVA Inner insole. .Duo foam Soft compressed Midsole With shank ",
    category: "Football",
    image: "https://m.media-amazon.com/images/I/61RpRYFb2wL._AC_UL320_.jpg",
    rating: {
      rate: 3.8,
      count: 170,
    },
  },
  {
    id: uuid(),
    title: "MattZig Ultimate Protection Football Kit",
    price: 294,
    description:
      "Kit contains One Pair Free Size Knee Length Football Socks and One Pair Football Shin Guard and One Pair UV Protection Arm Sleeves Football socks are made from superior quality lycra cotton and they help in keeping the feet dry and comfortable by wicking moisture away from the skin by quick evaporation.",
    category: "Football",
    image: "https://m.media-amazon.com/images/I/51Ax8cppctL._AC_UL320_.jpg",
    rating: {
      rate: 2.9,
      count: 470,
    },
  },
  {
    id: uuid(),
    title: "Klapp Champion Cricket Kit, Cricket Set",
    price: 3199,
    description:
      "Sales Package: 1 Kashmir Willow Cricket Bat(Size 4),1 Pair Pad, 1 Pair batting Gloves,1 Cricket Helmet,1 Thigh Pad, 1 Arm Guard,1 Abdominal Guard & 1 Kit Bag",
    category: "Cricket",
    image: "https://m.media-amazon.com/images/I/815-ZXvM04L._AC_UL320_.jpg",
    rating: {
      rate: 2.9,
      count: 470,
    },
  },
  {
    id: uuid(),
    title: "SG Full Cricket Kit with Duffle Bag and Trycom Brand Ball(with helmat)",
    price: 6999,
    description:
      "Cricket Kit Includes : Cricket Bat (with cover) + Legguard + Batting Gloves + Kitbag + Thigh Guard + Arm Guard + Abdo Guard+ Trycom Brand Ball+ Helmat ",
    category: "Cricket",
    image: "https://m.media-amazon.com/images/I/71KyUQ9vmwL._AC_UL320_.jpg",
    rating: {
      rate: 2.9,
      count: 470,
    },
  },
];
